import { Play } from "lucide-react";
import { Button } from "./ui/button";

export const HeroSection = () => {
  return (
    <section 
      className="relative min-h-[90vh] flex items-center justify-center overflow-hidden -mt-[calc(4rem+2.5rem)] md:-mt-[calc(5rem+2.5rem)]"
      aria-label="Hero section"
    >
      {/* Background - Otimizado para LCP (sem Framer Motion) */}
      <div className="absolute inset-0 z-0 hero-lcp-container">
        <picture>
          {/* Mobile: WebP Leve */}
          <source
            media="(max-width: 767px)"
            srcSet="/hero-mobile.webp"
            type="image/webp"
          />
          {/* Desktop: Poster WebP */}
          <source
            media="(min-width: 768px)"
            srcSet="/hero-poster.webp"
            type="image/webp"
          />
          {/* Fallback Img com fetchPriority */}
          <img
            src="/hero-mobile.webp"
            alt="Flooring Company Charlotte"
            width={800}
            height={600}
            className="h-full w-full object-cover hero-lcp-img"
            fetchPriority="high"
            loading="eager"
            decoding="sync"
          />
        </picture>
        
        {/* Video Desktop (carrega depois) */}
        <div className="hidden md:block absolute inset-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            poster="/hero-poster.webp"
            className="h-full w-full object-cover"
          >
            <source src="/hero-video.mp4" type="video/mp4" />
            <track kind="descriptions" src="/hero-captions.vtt" srcLang="en" label="English" />
          </video>
        </div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content - CSS animations instead of Framer Motion */}
      <div className="relative z-10 container-wide text-center pt-32 md:pt-40">
        <div className="max-w-4xl mx-auto animate-fade-in">
          {/* Label */}
          <p className="label-sm text-primary-foreground/80 mb-4 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            PREMIER FLOORING COMPANY
          </p>

          {/* Main Heading */}
          <h1 className="heading-xl text-white mb-6 text-balance">
            Flooring Company in{" "}
            <span className="text-primary-light">Charlotte, NC</span>
          </h1>

          {/* Subtitle */}
          <p className="body-lg text-white/80 mb-10 max-w-2xl mx-auto text-balance">
            Premier flooring company in the Carolinas. All materials and installation 
            for one low price. No hidden fees. No surprises.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <Button variant="hero" size="xl">
              FREE ESTIMATE
            </Button>
            <Button variant="heroOutline" size="xl" className="group">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white/20 group-hover:bg-white/30 transition-colors mr-2">
                <Play className="h-4 w-4 ml-0.5" />
              </span>
              WATCH: HOW WE DO IT
            </Button>
          </div>
        </div>

        {/* Scroll Indicator - CSS animation */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in" style={{ animationDelay: '0.8s' }}>
          <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1 animate-bounce">
            <div className="w-1.5 h-3 rounded-full bg-white/60" />
          </div>
        </div>
      </div>
    </section>
  );
};
